// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
};

// ----------------------------------------------------------------------

export const paths = {
  // MAIN
  main: {
    endUserLicenceAgreement: '/eula',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
  },
  // ERROR PAGES
  errors: {
    notFound: '/404',
    forbidden: '/403',
    insufficientRole: '/insufficient-role',
  },
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: '/',
    checkout: {
      root: '/checkout',
      reviewOrder: '/checkout/review-order',
      orderCreated: '/checkout/success',
    },
    userManagment: {
      root: '/user-managment',
      inviteUser: '/user-managment/invite-user',
      editUser: (id: string) => `/user-managment/edit-user/${id}`,
    },
    products: {
      addProduct: '/add-product',
      editDraft: (id: string) => `/products/draft/${id}`,
      edit: (id: string) => `/products/${id}`,
      root: '/products',
      productDetails: (stockId: string) => `/products/${stockId}`,
      componentDetails: (stockId: string, componentId: string) =>
        `/products/${stockId}/${componentId}`,
    },
    distributors: {
      root: '/distributors',
      addDistributor: '/distributors/add',
      distributorDetails: (id: string) => `/distributors/${id}`,
      distributorSiteDetails: (distributorOrgId: string, siteId: string) =>
        `/distributors/${distributorOrgId}/sites/${siteId}`,
    },
    producer: {
      root: '/producers',
      addProducer: '/add-producer',
      producerDetails: (producerId: string) => `/producers/${producerId}`,
    },
    favourites: {
      root: '/favourites',
    },
    orders: {
      root: '/orders',
      orderDetails: (orderId: string) => `/orders/${orderId}`,
      export: '/orders/export',
    },
    issues: {
      root: '/issues',
      issueDetails: (orderId: string, issueId: string) => `/orders/${orderId}/issues/${issueId}`,
      anonymousReply: (id: string) => `/order-issues-email/${id}`,
      anonymousReplySuccess: '/order-issues-email/success',
    },
    // TODO: Remove these paths
    editOrderProducts: (orderId: string) => `/edit-order/${orderId}/products`,
    editOrderCheckout: (orderId: string) => `/edit-order/${orderId}/checkout`,
    user: {
      root: '/user',
      changePassword: '/user/change-password',
    },
    news: {
      root: '/news',
      detail: (newsId: string) => `/news/${newsId}`,
    },
    stories: {
      root: '/stories',
    },
    seasonalCalendar: {
      root: `/seasonal-calendar`,
    },
    reporting: {
      root: '/reporting',
    },
    finance: {
      root: '/finance',
      invoiceDetails: (invoiceId: string) => `/finance/invoices/${invoiceId}`,
    },
  },
};
